import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export default function CustomSelect({
 value,
 onChange,
 options = [],
  placeholder = 'Sélectionner...',
  className = '',
  triggerClassName = '',
  disabled = false
}) {
 const [isOpen, setIsOpen] = useState(false);
 const containerRef = useRef(null);

 const selectedOption = options.find(opt => opt.value === value);

 // Fermer quand on clique en dehors
 useEffect(() => {
 const handleClickOutside = (event) => {
 if (containerRef.current && !containerRef.current.contains(event.target)) {
 setIsOpen(false);
 }
 };
 document.addEventListener('mousedown', handleClickOutside);
 return () => document.removeEventListener('mousedown', handleClickOutside);
 }, []);

  return (
    <div className={`relative ${className} ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`} ref={containerRef}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        className={`workspace-input flex items-center justify-between w-full text-left bg-surface ${disabled ? 'cursor-not-allowed' : 'hover:bg-surface-muted cursor-pointer'} ${triggerClassName}`}
        style={{ minHeight: '2.5rem', padding: '0.5rem 0.875rem' }}
      >
        <span className={`block truncate ${!selectedOption ? 'opacity-60' : ''}`}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
 <ChevronDown
 className={`w-4 h-4 text-tertiary transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
 />
 </button>

 <AnimatePresence>
 {isOpen && (
 <motion.div
 initial={{ opacity: 0, y: -5, scale: 0.98 }}
 animate={{ opacity: 1, y: 0, scale: 1 }}
 exit={{ opacity: 0, y: -5, scale: 0.98 }}
 transition={{ duration: 0.15, ease: "easeOut" }}
 className="absolute z-[90] mt-1 w-full bg-surface border border-workspace rounded-md shadow-hp-lg overflow-hidden"
 >
 <ul className="max-h-60 overflow-auto py-1">
 <li
 onClick={() => {
 onChange("");
 setIsOpen(false);
 }}
 className={`px-3 py-2 text-sm cursor-pointer transition-colors ${value === ""
 ? 'bg-primary-light text-primary font-medium'
 : 'text-tertiary hover:bg-surface-muted hover:text-primary'
 }`}
 >
 {placeholder}
 </li>

 {options.map((option) => (
 <li
 key={option.value}
 onClick={() => {
 if (option.disabled) return;
 onChange(option.value);
 setIsOpen(false);
 }}
 className={`px-3 py-2 text-sm transition-colors ${option.disabled ? 'opacity-50 cursor-not-allowed bg-surface-muted text-subtle' : 'cursor-pointer'} ${value === option.value && !option.disabled
 ? 'bg-primary-light text-primary font-medium'
 : (!option.disabled ? 'text-primary hover:bg-surface-muted' : '')
 }`}
 >
 {option.label}
 </li>
 ))}
 </ul>
 </motion.div>
 )}
 </AnimatePresence>
 </div>
 );
}
